(function () {
  function initHeader() {
    var open = document.querySelector('[data-lsh-menu]');
    var drawer = document.querySelector('[data-lsh-drawer]');
    var close = document.querySelector('[data-lsh-close]');
    if (!open || !drawer || open.dataset.ready) return;
    open.dataset.ready = 'true';
    function setDrawer(show) {
      drawer.hidden = !show;
      document.documentElement.classList.toggle('lsh-menu-open', show);
      open.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (show) close.focus();
      else open.focus();
    }
    open.setAttribute('aria-expanded', 'false');
    open.setAttribute('aria-controls', 'LuminoireMobileMenu');
    drawer.id = 'LuminoireMobileMenu';
    open.addEventListener('click', function () { setDrawer(true); });
    close.addEventListener('click', function () { setDrawer(false); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) setDrawer(false);
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var activeGalleryIndex = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var galleryShown = false;
    var galleryAutoplay = root.dataset.galleryAutoplay !== 'false' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var galleryMuted = null;
    var playbackAttempts = new WeakMap();
    function playGalleryVideo(slide, manual) {
      var video = slide.querySelector('[data-gallery-video] video');
      if (!video || !slide.classList.contains('is-active')) return;
      var error = slide.querySelector('[data-gallery-video-error]');
      if (error) error.hidden = true;
      if (video.error) video.load();
      if (manual && galleryMuted === null) galleryMuted = false;
      video.defaultMuted = video.muted = galleryMuted === null ? true : galleryMuted;
      if (!video.muted && video.volume === 0) video.volume = 1;
      var attempt = (playbackAttempts.get(video) || 0) + 1;
      playbackAttempts.set(video, attempt);
      var playback = video.play();
      if (playback && playback.catch) {
        playback.catch(function (reason) {
          if (playbackAttempts.get(video) !== attempt || !slide.classList.contains('is-active')) return;
          if (reason.name === 'NotAllowedError' && !manual && !video.muted) {
            video.defaultMuted = video.muted = true;
            video.play().catch(function () {});
            return;
          }
          if (reason.name !== 'AbortError' && reason.name !== 'NotAllowedError' && error) error.hidden = false;
          var button = slide.querySelector('[data-gallery-video-play]');
          if (button) button.hidden = false;
        });
      }
    }
    slides.forEach(function (slide) {
      var player = slide.querySelector('[data-gallery-video]');
      if (!player) return;
      var video = player.querySelector('video');
      var button = player.querySelector('[data-gallery-video-play]');
      var error = player.querySelector('[data-gallery-video-error]');
      var controls = player.querySelector('[data-gallery-video-controls]');
      var toggle = player.querySelector('[data-gallery-video-toggle]');
      var mute = player.querySelector('[data-gallery-video-mute]');
      var seek = player.querySelector('[data-gallery-video-seek]');
      var fullscreen = player.querySelector('[data-gallery-video-fullscreen]');
      function syncControls() {
        var paused = video.paused || video.ended;
        var muted = video.muted || video.volume === 0;
        button.hidden = !paused;
        toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        toggle.querySelector('[data-video-play-icon]').toggleAttribute('hidden', !paused);
        toggle.querySelector('[data-video-pause-icon]').toggleAttribute('hidden', paused);
        mute.setAttribute('aria-label', muted ? mute.dataset.unmuteLabel : mute.dataset.muteLabel);
        mute.querySelector('[data-video-sound-on]').toggleAttribute('hidden', muted);
        mute.querySelector('[data-video-sound-off]').toggleAttribute('hidden', !muted);
        mute.querySelector('[data-video-unmute-text]').hidden = !muted;
        seek.disabled = !Number.isFinite(video.duration) || video.duration <= 0;
        if (!seek.disabled) seek.value = video.currentTime / video.duration * 100;
      }
      function pauseVideo() {
        playbackAttempts.set(video, (playbackAttempts.get(video) || 0) + 1);
        video.pause();
        syncControls();
      }
      player.classList.add('is-ready');
      video.controls = false;
      controls.hidden = false;
      ['pointerdown', 'mousedown', 'touchstart', 'touchend', 'click', 'wheel'].forEach(function (type) {
        controls.addEventListener(type, function (event) { event.stopPropagation(); });
      });
      button.addEventListener('click', function () { playGalleryVideo(slide, true); });
      toggle.addEventListener('click', function () {
        if (video.paused || video.ended) playGalleryVideo(slide, true);
        else pauseVideo();
      });
      mute.addEventListener('click', function () {
        var wasPlaying = !video.paused;
        galleryMuted = !(video.muted || video.volume === 0);
        video.defaultMuted = video.muted = galleryMuted;
        if (!galleryMuted && video.volume === 0) video.volume = 1;
        if (wasPlaying) playGalleryVideo(slide, false);
        syncControls();
      });
      seek.addEventListener('input', function () {
        if (Number.isFinite(video.duration)) video.currentTime = video.duration * Number(seek.value) / 100;
      });
      fullscreen.addEventListener('click', function () {
        if (document.fullscreenElement && document.exitFullscreen) {
          document.exitFullscreen().catch(function () {});
        } else if (player.requestFullscreen) {
          player.requestFullscreen().catch(function () {});
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      });
      fullscreen.hidden = !player.requestFullscreen && !video.webkitEnterFullscreen;
      video.addEventListener('playing', function () {
        if (!slide.classList.contains('is-active')) {
          video.pause();
          return;
        }
        button.hidden = true;
        error.hidden = true;
      });
      ['play', 'pause', 'ended', 'volumechange', 'loadedmetadata', 'durationchange', 'timeupdate'].forEach(function (event) {
        video.addEventListener(event, syncControls);
      });
      video.addEventListener('error', function () {
        button.hidden = false;
        error.hidden = false;
      });
      syncControls();
    });
    slides.forEach(function (slide) { slide.hidden = false; });
    function getActiveIndex() {
      return activeGalleryIndex;
    }
    function positionSlides(index, animate) {
      slides.forEach(function (slide) {
        slide.style.transition = animate === false ? 'none' : '';
        slide.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
        if (animate === false) {
          slide.offsetHeight;
          slide.style.transition = '';
        }
      });
    }
    function show(index, animate) {
      if (!slides.length) return;
      var safeIndex = (index + slides.length) % slides.length;
      var changed = !galleryShown || safeIndex !== activeGalleryIndex;
      activeGalleryIndex = safeIndex;
      positionSlides(safeIndex, animate);
      slides.forEach(function (slide, i) {
        var selected = i === safeIndex;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        slide.inert = !selected;
        var video = slide.querySelector('video');
        if (video && !selected) video.pause();
      });
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === safeIndex); thumb.setAttribute('aria-selected', i === safeIndex ? 'true' : 'false'); });
      galleryShown = true;
      if (changed && galleryAutoplay) playGalleryVideo(slides[safeIndex], false);
    }
    function moveGallery(direction) {
      show(getActiveIndex() + direction);
    }
    show(activeGalleryIndex, false);
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { show(Number(thumb.dataset.galleryThumb)); }); });
    root.querySelectorAll('[data-gallery-jump]').forEach(function (button) { button.addEventListener('click', function () { show(Number(button.dataset.galleryJump)); window.scrollTo({top: 0, behavior: 'smooth'}); }); });
    function bindGalleryArrow(selector, direction) {
      root.querySelectorAll(selector).forEach(function (button) {
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
          button.addEventListener(type, function (event) { event.stopPropagation(); }, {passive: true});
        });
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          moveGallery(direction);
        });
      });
    }
    bindGalleryArrow('[data-gallery-prev]', -1);
    bindGalleryArrow('[data-gallery-next]', 1);

    var stage = root.querySelector('.lst-pdp-stage');
    if (stage && slides.length > 1) {
      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var tracking = false;
      var dragging = false;
      var lastSwipeAt = 0;
      var ignoreSelector = 'a, button, input, textarea, select, video, [data-gallery-thumb], [data-gallery-prev], [data-gallery-next]';
      function beginSwipe(x, y, target) {
        if (target && target.closest && target.closest(ignoreSelector)) return;
        startX = x;
        startY = y;
        lastX = x;
        tracking = true;
        dragging = false;
        stage.classList.add('is-dragging');
      }
      function updateSwipe(x, y) {
        if (!tracking) return;
        var deltaX = x - startX;
        var deltaY = y - startY;
        if (!dragging && Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) dragging = true;
        if (!dragging) return;
        lastX = x;
        slides.forEach(function (slide) {
          slide.style.transition = 'none';
          slide.style.transform = 'translate3d(calc(' + (-activeGalleryIndex * 100) + '% + ' + deltaX + 'px),0,0)';
        });
      }
      function resetDragPosition() {
        stage.classList.remove('is-dragging');
        positionSlides(activeGalleryIndex, true);
      }
      function finishSwipe(x, y) {
        if (!tracking) return;
        tracking = false;
        var deltaX = x - startX;
        var deltaY = y - startY;
        var now = Date.now();
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15 || now - lastSwipeAt < 250) {
          resetDragPosition();
          return;
        }
        lastSwipeAt = now;
        stage.classList.remove('is-dragging');
        moveGallery(deltaX < 0 ? 1 : -1);
      }
      // Desktop trackpads emit wheel events without a pointer press.
      // Consume horizontal gestures only, leaving page scrolling and pinch zoom native.
      var wheelDistance = 0;
      var wheelMoved = false;
      var wheelLastAt = 0;
      var wheelLastDelta = 0;
      var wheelMoveAt = 0;
      stage.addEventListener('wheel', function (event) {
        if (event.ctrlKey || tracking) return;
        var horizontal = event.deltaX;
        var vertical = event.deltaY;
        if (event.shiftKey && !horizontal) {
          horizontal = vertical;
          vertical = 0;
        }
        if (!horizontal || Math.abs(horizontal) <= Math.abs(vertical)) return;
        event.preventDefault();
        var now = performance.now();
        var unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? stage.clientWidth : 1;
        var delta = horizontal * unit;
        var reversed = wheelLastDelta && Math.sign(delta) !== Math.sign(wheelLastDelta);
        // A pause, direction change, or renewed acceleration starts a fresh swipe.
        // Decaying momentum alone cannot keep the gallery locked or skip slides.
        var renewed = now - wheelMoveAt > 200 && Math.abs(delta) >= 4 &&
          Math.abs(delta) > Math.abs(wheelLastDelta) * 1.5;
        if (now - wheelLastAt > 90 || reversed || (wheelMoved && renewed)) {
          wheelDistance = 0;
          wheelMoved = false;
        }
        wheelLastAt = now;
        wheelLastDelta = delta;
        if (wheelMoved) return;
        wheelDistance += delta;
        if (Math.abs(wheelDistance) >= 16) {
          wheelMoved = true;
          wheelMoveAt = now;
          moveGallery(wheelDistance > 0 ? 1 : -1);
        }
      }, {passive: false});
      stage.addEventListener('dragstart', function (event) { event.preventDefault(); });
      if (window.PointerEvent) {
        stage.addEventListener('pointerdown', function (event) {
          beginSwipe(event.clientX, event.clientY, event.target);
          if (tracking && stage.setPointerCapture) {
            try { stage.setPointerCapture(event.pointerId); } catch (error) {}
          }
        });
        stage.addEventListener('pointermove', function (event) { updateSwipe(event.clientX, event.clientY); });
        window.addEventListener('pointermove', function (event) { updateSwipe(event.clientX, event.clientY); });
        stage.addEventListener('pointerup', function (event) { finishSwipe(event.clientX, event.clientY); });
        window.addEventListener('pointerup', function (event) { finishSwipe(event.clientX, event.clientY); });
        stage.addEventListener('pointercancel', function () { tracking = false; resetDragPosition(); });
      } else {
        stage.addEventListener('mousedown', function (event) {
          if (event.button !== 0) return;
          beginSwipe(event.clientX, event.clientY, event.target);
        });
        stage.addEventListener('mousemove', function (event) { updateSwipe(event.clientX, event.clientY); });
        window.addEventListener('mousemove', function (event) { updateSwipe(event.clientX, event.clientY); });
        window.addEventListener('mouseup', function (event) { finishSwipe(event.clientX, event.clientY); });
      }
      stage.addEventListener('touchstart', function (event) {
        if (!event.changedTouches.length) return;
        beginSwipe(event.changedTouches[0].clientX, event.changedTouches[0].clientY, event.target);
      }, {passive: true});
      stage.addEventListener('touchmove', function (event) {
        if (!event.changedTouches.length) return;
        updateSwipe(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
      }, {passive: true});
      stage.addEventListener('touchend', function (event) {
        if (!event.changedTouches.length) return;
        finishSwipe(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
      }, {passive: true});
    }

    root.querySelectorAll('[data-lst-quantity]').forEach(function (quantity) {
      var input = quantity.querySelector('input');
      quantity.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, Number(input.value || 1) - 1); });
      quantity.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = Math.max(1, Number(input.value || 1) + 1); });
    });

    var form = root.querySelector('.lst-product-form');
    var add = root.querySelector('[data-lst-atc], .lst-product-form [name="add"]');
    if (form && add) form.addEventListener('submit', async function (event) {
      var drawer = document.querySelector('m-cart-drawer');
      if (!drawer) return;
      event.preventDefault();
      if (add.getAttribute('aria-busy') === 'true') return;
      add.classList.add('is-loading');
      add.setAttribute('aria-busy', 'true');
      var error = form.querySelector('[data-cart-error]');
      if (!error) {
        error = document.createElement('p');
        error.setAttribute('data-cart-error', '');
        error.setAttribute('role', 'alert');
        form.appendChild(error);
      }
      error.textContent = '';
      try {
        var sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {bubbles: true, detail: {sections: sections}}));
        var data = new FormData(form);
        data.set('sections', sections.join(','));
        data.set('sections_url', window.location.pathname);
        var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method: 'POST', body: data, headers: {'X-Requested-With': 'XMLHttpRequest'}});
        var cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || 'Unable to add this item. Please try again.');
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {cart: cart, productVariantId: data.get('id')});
        drawer.open(add);
      } catch (problem) {
        error.textContent = problem.message;
      } finally {
        add.classList.remove('is-loading');
        add.removeAttribute('aria-busy');
      }
    });
    var sticky = root.querySelector('[data-lst-sticky-buy]');
    var stickySubmit = root.querySelector('[data-lst-sticky-submit]');
    if (sticky && add) {
      const setSticky = visible => {
        sticky.classList.toggle('is-visible', visible);
        sticky.inert = !visible;
        sticky.setAttribute('aria-hidden', String(!visible));
      };
      setSticky(false);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          setSticky(!entries[0].isIntersecting);
        }, {threshold: 0});
        observer.observe(add);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) observer.disconnect();
        });
      }
      const syncStickyButton = () => {
        if (!stickySubmit) return;
        stickySubmit.disabled = add.disabled || add.getAttribute('aria-busy') === 'true';
        stickySubmit.setAttribute('aria-busy', add.getAttribute('aria-busy') || 'false');
        stickySubmit.textContent = add.querySelector('[data-atc-label]')?.textContent || add.textContent;
      };
      syncStickyButton();
      const buttonObserver = new MutationObserver(syncStickyButton);
      buttonObserver.observe(add, {attributes:true, attributeFilter:['disabled', 'aria-busy'], childList:true, subtree:true, characterData:true});
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) buttonObserver.disconnect();
      });
    }
    if (stickySubmit && add) stickySubmit.addEventListener('click', function () {
      if (!add.disabled && add.getAttribute('aria-busy') !== 'true') add.click();
    });
  }

  function initDetailing(scope) {
    (scope || document).querySelectorAll('[data-lst-detailing]').forEach(function (root) {
      if (root.dataset.lstDetailingReady === 'true') return;
      root.dataset.lstDetailingReady = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lst-detailing-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lst-detailing-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;

      function select(index, moveFocus) {
        tabs.forEach(function (tab, tabIndex) {
          var active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && moveFocus) tab.focus();
        });
        panels.forEach(function (panel, panelIndex) {
          var active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(index, false); });
        tab.addEventListener('keydown', function (event) {
          var next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        });
      });

      select(Math.max(0, tabs.findIndex(function (tab) { return tab.classList.contains('is-active'); })), false);
    });
  }

  function initAttachments(scope) {
    (scope || document).querySelectorAll('[data-lst-attachments]').forEach(function (root) {
      if (root.dataset.lstAttachmentsReady === 'true') return;
      root.dataset.lstAttachmentsReady = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lst-attachment-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lst-attachment-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;

      function select(index, moveFocus) {
        tabs.forEach(function (tab, tabIndex) {
          var active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && moveFocus) tab.focus();
        });
        panels.forEach(function (panel, panelIndex) {
          var active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(index, false); });
        tab.addEventListener('keydown', function (event) {
          var next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        });
      });

      select(Math.max(0, tabs.findIndex(function (tab) { return tab.classList.contains('is-active'); })), false);
    });
  }

  function normalizeReviewCount(root) {
    var reviewCount = '374';
    var reviewRating = '4.9';
    var countPattern = /\d[\d,]*(?=\s+reviews?\b)/i;
    var ratingPattern = /\b[0-5](?:\.\d+)?(?=\s*(?:out of 5|\/\s*5))/i;
    var countSelectors = [
      '.jm-review-widget--minimal-header .jm-cluster .jm-text',
      '.jm-average-rating-display--minimal-header .jm-text',
      '.jdgm-rev-widg__summary-text',
      '.jdgm-all-reviews-text'
    ].join(',');

    root.querySelectorAll(countSelectors).forEach(function (element) {
      if (element.children.length || !countPattern.test(element.textContent || '')) return;
      var nextText = element.textContent.replace(countPattern, reviewCount);
      if (element.textContent !== nextText) element.textContent = nextText;
    });

    var ratingSelectors = [
      '.jm-average-rating-display--minimal-header .jm-text',
      '.jdgm-rev-widg__summary-average',
      '.jdgm-prev-badge__text'
    ].join(',');

    root.querySelectorAll(ratingSelectors).forEach(function (element) {
      if (element.children.length) return;
      var currentText = element.textContent || '';
      var nextText = currentText.replace(ratingPattern, reviewRating);
      if (/^\s*[0-5](?:\.\d+)?\s*$/.test(currentText)) nextText = currentText.replace(/[0-5](?:\.\d+)?/, reviewRating);
      if (currentText !== nextText) element.textContent = nextText;
    });

    root.querySelectorAll('*').forEach(function (element) {
      ['aria-label', 'title'].forEach(function (attribute) {
        var value = element.getAttribute(attribute);
        if (!value) return;
        var nextValue = value.replace(countPattern, reviewCount).replace(ratingPattern, reviewRating);
        if (value !== nextValue) element.setAttribute(attribute, nextValue);
      });
    });
    if (window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget) {
      Object.keys(window.jdgm.data.reviewWidget).forEach(function (key) {
        var record = window.jdgm.data.reviewWidget[key];
        if (!record) return;
        record.number_of_reviews = Number(reviewCount);
        if ('rating' in record) record.rating = Number(reviewRating);
        if ('average_rating' in record) record.average_rating = Number(reviewRating);
        if (record.review_summary_text) record.review_summary_text = record.review_summary_text.replace(countPattern, reviewCount);
        if (record.number_of_reviews_text) record.number_of_reviews_text = record.number_of_reviews_text.replace(countPattern, reviewCount);
      });
    }
  }

  function initReviewFilters(scope) {
    (scope || document).querySelectorAll('.lst-reviews').forEach(function (root) {
      normalizeReviewCount(root);
      var select = root.querySelector('select.jdgm-sort-dropdown, select.jm-sort-filter__select');
      if (!select) return;

      var filterText = root.querySelector('.jm-custom-answer-filter__text');
      if (filterText) filterText.textContent = 'Filter reviews';
      select.setAttribute('aria-label', 'Sort customer reviews');

      if (root.dataset.lstReviewSortReady === 'true') return;
      root.dataset.lstReviewSortReady = 'true';
      if (select.querySelector('option[value="pictures_first"]')) {
        select.value = 'pictures_first';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function initTextReviewSliders(scope) {
    (scope || document).querySelectorAll('[data-lst-text-reviews]').forEach(function (root) {
      if (root.dataset.lstTextReviewsReady === 'true') return;
      root.dataset.lstTextReviewsReady = 'true';

      var allSlides = Array.prototype.slice.call(root.querySelectorAll('[data-lst-text-review]'));
      var previous = root.querySelector('[data-lst-review-prev]');
      var next = root.querySelector('[data-lst-review-next]');
      var currentLabel = root.querySelector('[data-lst-review-current]');
      var totalLabel = root.querySelector('[data-lst-review-total]');
      var activeSlide = allSlides[0];
      var timer;
      var transitionTimer;
      var touchStartX = 0;

      function availableSlides() {
        return allSlides.filter(function (slide) { return window.getComputedStyle(slide).display !== 'none'; });
      }

      function updatePosition(slides) {
        var position = Math.max(0, slides.indexOf(activeSlide));
        if (currentLabel) currentLabel.textContent = String(position + 1).padStart(2, '0');
        if (totalLabel) totalLabel.textContent = String(slides.length).padStart(2, '0');
        if (previous) previous.disabled = slides.length < 2;
        if (next) next.disabled = slides.length < 2;
      }

      function show(target, animate) {
        var slides = availableSlides();
        if (!slides.length) return;
        var targetIndex = ((target % slides.length) + slides.length) % slides.length;
        var nextSlide = slides[targetIndex];
        var oldSlide = activeSlide;
        window.clearTimeout(transitionTimer);

        allSlides.forEach(function (slide) {
          if (slide !== oldSlide) slide.classList.remove('is-active', 'is-leaving');
          slide.setAttribute('aria-hidden', slide === nextSlide ? 'false' : 'true');
        });

        if (oldSlide && oldSlide !== nextSlide && animate !== false) {
          oldSlide.classList.remove('is-active');
          oldSlide.classList.add('is-leaving');
          transitionTimer = window.setTimeout(function () { oldSlide.classList.remove('is-leaving'); }, 560);
        } else if (oldSlide && oldSlide !== nextSlide) {
          oldSlide.classList.remove('is-active', 'is-leaving');
        }

        nextSlide.classList.remove('is-leaving');
        nextSlide.classList.add('is-active');
        activeSlide = nextSlide;
        updatePosition(slides);
      }

      function move(amount) {
        var slides = availableSlides();
        var position = slides.indexOf(activeSlide);
        show((position < 0 ? 0 : position) + amount, true);
      }

      function stopAutoplay() { window.clearInterval(timer); }
      function startAutoplay() {
        stopAutoplay();
        if (root.dataset.autoplay === 'true' && availableSlides().length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(function () { move(1); }, Number(root.dataset.interval || 7000));
        }
      }

      if (previous) previous.addEventListener('click', function () { move(-1); startAutoplay(); });
      if (next) next.addEventListener('click', function () { move(1); startAutoplay(); });
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);
      root.addEventListener('touchstart', function (event) { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (event) {
        var distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) > 45) move(distance < 0 ? 1 : -1);
        startAutoplay();
      }, { passive: true });
      root.addEventListener('shopify:block:select', function (event) {
        var selectedSlide = event.target.closest('[data-lst-text-review]');
        var slides = availableSlides();
        if (selectedSlide && slides.indexOf(selectedSlide) >= 0) show(slides.indexOf(selectedSlide), false);
      });
      window.addEventListener('resize', function () {
        var slides = availableSlides();
        show(Math.max(0, slides.indexOf(activeSlide)), false);
      });

      show(0, false);
      startAutoplay();
    });
  }

  function initHomeLiveChat() {
    if (!document.body.classList.contains('template-index')) return;
    var attempts = 0;

    function activate() {
      var root = document.querySelector('.ktwa-wrap');
      if (root && root.dataset.lstHomeChatReady === 'true') return;
      if (typeof ktwacdn !== 'undefined' && typeof ktwa !== 'undefined' && typeof ktwa.init === 'function') {
        ktwacdn.home = true;
        ktwa.init();
        root = document.querySelector('.ktwa-wrap');
        if (root) root.dataset.lstHomeChatReady = 'true';
        return;
      }
      attempts += 1;
      if (attempts < 24) window.setTimeout(activate, 250);
    }

    activate();
  }

  let stopReviewScroll;
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-lst-review-link]');
    if (!link) return;
    const section = document.querySelector('.lst-reviews');
    if (!section) return;
    event.preventDefault();
    event.stopPropagation();
    stopReviewScroll?.();
    const target = section.querySelector('h2, h3, .m-section__heading') || section;
    const controller = new AbortController();
    let correctionTimer;
    let expiry;
    const top = () => {
      let offset = 20;
      document.querySelectorAll('.lsh-header, .m-header, sticky-header, .shopify-section-header').forEach(header => {
        const rect = header.getBoundingClientRect();
        const position = getComputedStyle(header).position;
        if ((position === 'fixed' || position === 'sticky') && rect.top <= 1 && rect.bottom > 0) offset = Math.max(offset, rect.bottom + 20);
      });
      return Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
    };
    const align = () => window.scrollTo({top:top(), behavior:'instant'});
    const observer = new ResizeObserver(() => {
      clearTimeout(correctionTimer);
      correctionTimer = setTimeout(align, 180);
    });
    stopReviewScroll = () => {
      controller.abort();
      observer.disconnect();
      clearTimeout(correctionTimer);
      clearTimeout(expiry);
    };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, stopReviewScroll, {once:true, passive:true, signal:controller.signal}));
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll:true});
    history.replaceState(null, '', '#luminoire-customer-reviews');
    window.scrollTo({top:top(), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    correctionTimer = setTimeout(() => { align(); observer.observe(document.body); }, 700);
    expiry = setTimeout(stopReviewScroll, 3500);
  }, true);

  function init() {
    initHeader();
    document.querySelectorAll('[data-lst-product]').forEach(initProduct);
    initDetailing(document);
    initAttachments(document);
    initReviewFilters(document);
    initTextReviewSliders(document);
    initHomeLiveChat();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);

  var reviewFilterRefreshPending = false;
  new MutationObserver(function (mutations) {
    var shouldRefresh = mutations.some(function (mutation) {
      if (mutation.type === 'childList') return true;
      var parent = mutation.target.parentElement;
      return Boolean(parent && parent.closest('.lst-reviews'));
    });
    if (!shouldRefresh) return;
    if (reviewFilterRefreshPending) return;
    reviewFilterRefreshPending = true;
    requestAnimationFrame(function () {
      reviewFilterRefreshPending = false;
      initReviewFilters(document);
      });
  }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
})();
